import { Airline4XRules } from './server-constants';

/** Registered technology IDs shared by the tree and commercial action eligibility. */
export const COMMERCIAL_TECHNOLOGIES = {
  advisor: 'research_methods',
  wonder: 'market_intelligence_center_blueprint',
} as const;
export const WONDER_PLACEMENT_COST = Airline4XRules.commercial.wonder_cost; // millions of dollars
export const FRANCHISE_SURVEY_COST = Airline4XRules.commercial.survey_cost;
